import ApiService from '../services/apiService';

export const initOnboardingSubscriptionRequest = ({ dispatch, params, failureCallback, successCallback }) =>
  ApiService.request('post', '/onboarding/subscriptions/init', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const confirmOnboardingSubscriptionRequest = ({ dispatch, params, failureCallback, successCallback }) =>
  ApiService.request('post', '/onboarding/subscriptions/confirm', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const redirectToTransbankForm = ({ serviceUrl, token, fieldName = 'TBK_TOKEN' }) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = serviceUrl;
  form.style.display = 'none';

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = fieldName;
  tokenInput.value = token;
  form.appendChild(tokenInput);

  document.body.appendChild(form);
  form.submit();
};

export const redirectToWebpayPlus = ({ url, token }) => {
  window.location.href = `${url}?token_ws=${token}`;
};
